import React, { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from 'react-router-dom';
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import Dashboard from "../../pages/dashboard/Dashboard";
import layoutJSON from './layout.json'
import AdminManagement from "../../pages/adminManagement/AdminManagement";
import CustomerMangment from "../../pages/Customer Managment/CustomerMangment";
import MessageManagement from "../../pages/Message Management/MessageManagement";
import { userActions } from "../../_actions";
import { useDispatch, useSelector } from "react-redux";
import Notification from "../../pages/Notification/Notification";

const routeConfig = [
  { path: '/dashboard', element: <Dashboard />, access: ['add_customer', 'view_customer', 'edit_customer', 'customer_manag'] },
  { path: '/customer', element: <CustomerMangment />, access: ['add_customer', 'view_customer', 'edit_customer', 'customer_manag'] },
  { path: '/admin', element: <AdminManagement />, access: ['admin_manag'] },
  { path: '/message', element: <MessageManagement />, access: ['msg_manag'] },
  { path: '/notification', element: <Notification />, access: ['noti_manag'] },
];

function Layout() {
  const navigate = useNavigate();
  let dispatch = useDispatch()
  const [navbarOpen, setNavbarOpen] = React.useState(false);
  const [headerName, setHeaderName] = useState('');
  
  const admindata = useSelector(state => state.users?.adminData);
  // let userAccess = JSON.parse(window.sessionStorage.getItem("adminuser"));
  let userAccess = admindata?.access || "";
  const userAccessArr = userAccess?.split(",") || [];
  useEffect(() => {
    dispatch(userActions.getProfile());
    let initialHeader = "/app/dashboard";
    if (!userAccess.includes("customer") && userAccess.includes("admin_manag")) {
      initialHeader = "/app/admin";
      navigate("/app/admin");
    } else if (!userAccess.includes("customer") && userAccess.includes("msg_manag")) {
      initialHeader = "/app/message";
      navigate("/app/message");
    } else if (!userAccess.includes("customer") && userAccess.includes("noti_manag")) {
      initialHeader = "/app/notification";
      navigate("/app/notification");
    }
    setHeaderName(initialHeader);
    dispatch(userActions.saveAccess(userAccessArr));
  }, []);
  useEffect(() => {
    if (window.location.href.includes("customer")) {
      setHeaderName("/app/customer");
    } else if(window.location.href.includes("admin")) {
      setHeaderName("/app/admin");
    } else if(window.location.href.includes("notification")) {
      setHeaderName("/app/notification");
    } else if(window.location.href.includes("message")) {
      setHeaderName("/app/message");
    }
  }, []);

  const validateRoutes = (routes, access) => {
    return routes.filter(route =>
      route.access.some(role => access.includes(role))
    );
  };

  const validRoutes = validateRoutes(routeConfig, userAccess);

  return (
    <div>
      <div className="overflow-hidden bg-white">
        <div className="min-h-screen flex flex-col justify-center">
          <div className="h-screen flex overflow-hidden">
            <Sidebar navbarOpen={navbarOpen} setNavbarOpen={setNavbarOpen} SidebarJSON={layoutJSON.sidebarJSON} setHeaderName={setHeaderName} />
            <div className="flex flex-col w-0 flex-1 overflow-hidden">
              <Header navbarOpen={navbarOpen} setNavbarOpen={setNavbarOpen} HeaderJSON={layoutJSON.headerJSON} headerName={headerName} />
              <Routes>
                {validRoutes.map((route, index) => (
                  <Route key={index} path={route.path} element={route.element} />
                ))}
              </Routes>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Layout;
